export const normalizeProductionUnitSearchText = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("fr")
    .trim();

export const matchesProductionUnitSearch = (label, query) => {
  const normalizedQuery = normalizeProductionUnitSearchText(query);
  if (!normalizedQuery) return true;

  const normalizedLabel = normalizeProductionUnitSearchText(label);
  return normalizedQuery
    .split(/\s+/)
    .every((token) => normalizedLabel.includes(token));
};
